import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { getProfile, createAddress } from '../../services/UserService';
import { createOrder } from '../../services/OrderService';
import { ShopperRequest } from '../../services/ProductService'
import { CartAdd, CartRmv } from "../../store/actions/CartActions"

import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const paymentMethodsNIDs = [
    { id: '0c67aacd-4242-4cc1-a56c-24d642287f4b', method: 'CARTÃO DE DÉBITO' },
    { id: '244a92b6-8cc2-4c33-a6ea-37ad48dcb17e', method: 'CARTÃO DE CRÉDITO' },
    { id: '40270f4a-df53-46ab-8764-effb596f8daa', method: 'TRANSFERÊNCIA BANCÁRIA' },
    { id: '6dbf0c66-c794-4b61-888c-ad6d06161583', method: 'PIX' },
    { id: 'dbe187b9-a64c-4dca-92d0-2f2e140e0f17', method: 'DINHEIRO' },
    { id: 'ed061e9a-40cb-4ef8-9353-4c8c346c563d', method: 'BOLETO BANCÁRIO' },
]

const FoodOrder = () => {
    let letcartDummy = JSON.parse(localStorage.getItem('cart'))
    const cartDummy = letcartDummy ? letcartDummy : { cart: {} }
    const valorTotalDummy = cartDummy.cart.itens ? cartDummy.cart.itens.reduce((acc, item) => acc + (item.produto.salePrice * item.quantidade), 0) : 0
    const quantidadeTotalDummy = cartDummy.cart.itens ? cartDummy.cart.itens.reduce((acc, item) => acc + item.quantidade, 0) : 0
    const [loading, setLoading] = useState(true);
    const [cart, setCart] = useState(cartDummy);
    const [shopper, setShopper] = useState(null);
    const [partner, setPartner] = useState(null);
    const [modalAddress, setModalAddress] = useState(false)
    const [modalNewAddress, setModalNewAddress] = useState(false)
    const [modalPayment, setModalPayment] = useState(false)
    const [modalSendOrder, setModalSendOrder] = useState(false)
    const [modalSendOrderDone, setModalSendOrderDone] = useState(false)
    const [deliveryAddressId, setDeliveryAddressId] = useState(() => {
        const storedAddress = localStorage.getItem('addressesTemp');
        if (storedAddress) {
            try {
                const parsed = JSON.parse(storedAddress);
                return parsed?.id || null;
            } catch (error) {
                console.error('Erro ao ler addressesTemp:', error);
                return null;
            }
        }
        return null;
    });
    const [deliveryAddresses, setDeliveryAddresses] = useState([])
    const [paymentId, setPaymentId] = useState('-')
    const [itens, setItens] = useState(cartDummy.cart.itens)
    const [valorTotal, setValorTotal] = useState(valorTotalDummy)
    const [quantidadeTotal, setQuantidadeTotal] = useState(quantidadeTotalDummy)
    const [qtd, setQtd] = useState(0);
    const [orderDiscount] = useState(0.5)
    const [orderID, setOrderID] = useState('')
    const [sendingOrder, setSendingOrder] = useState(false)

    const qtfcr = (ope, data) => {
        let cartDummy = JSON.parse(localStorage.getItem('cart'))
        if (!cartDummy || !cartDummy.cart.loja || !cartDummy.cart.loja.id) {
            return;
        } else {
            if (ope === 'plus') {
                let dummyValue = CartAdd(data)
                setCart(dummyValue)
                setItens(dummyValue.cart.itens)
                const newValorTotal = dummyValue.cart.itens.reduce((acc, item) => acc + (item.produto.salePrice * item.quantidade), 0);
                const newQuantidadeTotal = dummyValue.cart.itens.reduce((acc, item) => acc + item.quantidade, 0);
                setValorTotal(newValorTotal);
                setQuantidadeTotal(newQuantidadeTotal);
            } else if (ope === 'minus') {
                let dummyValue = CartRmv(data)
                setCart(dummyValue)
                setItens(dummyValue.cart.itens)
                const newValorTotal = dummyValue.cart.itens.reduce((acc, item) => acc + (item.produto.salePrice * item.quantidade), 0);
                const newQuantidadeTotal = dummyValue.cart.itens.reduce((acc, item) => acc + item.quantidade, 0);
                setValorTotal(newValorTotal);
                setQuantidadeTotal(newQuantidadeTotal);
            }
        }
    };

    const getQtdInCart = (productId) => {
        const cartDummy = JSON.parse(localStorage.getItem('cart'));
        if (cartDummy && cartDummy.cart && cartDummy.cart.itens) {
            const item = cartDummy.cart.itens.find(i => i.produto && i.produto.id === productId);
            return item ? item.quantidade : 0;
        }
        return 0;
    };

    useEffect(() => {
        let dummy = JSON.stringify(cart)
        localStorage.setItem('cart', dummy)
    }, [cart]);

    useEffect(() => {
        const cartDummy = JSON.parse(localStorage.getItem('cart'));
        if (cartDummy && cartDummy.cart && cartDummy.cart.itens) {
            setItens(cartDummy.cart.itens);
            const newValorTotal = cartDummy.cart.itens.reduce((acc, item) => acc + (item.produto.salePrice * item.quantidade), 0);
            const newQuantidadeTotal = cartDummy.cart.itens.reduce((acc, item) => acc + item.quantidade, 0);
            setValorTotal(newValorTotal);
            setQuantidadeTotal(newQuantidadeTotal);

            let somaQuantidades = 0;
            if (cartDummy.cart.itens && cartDummy.cart.itens.length > 0) {
                cartDummy.cart.itens.forEach(item => {
                    if (item.hasOwnProperty('quantidade')) {
                        somaQuantidades += item.quantidade;
                    }
                });
            }
            setQtd(somaQuantidades);
        } else {
            setQtd(0);
        }
    }, [cart]);

    const checkProfile = async () => {
        try {
            const response = await getProfile();

            if (response.status !== 200) {
                console.error('Erro ao checar profile:', response.statusText);
                return;
            }

            setShopper(response.data);

            const serverAddresses = response.data.addresses || [];
            const storedAddressesTemp = JSON.parse(localStorage.getItem('addressesTemp') || '[]');
            
            // 1 — Se servidor NÃO tem endereços e localStorage TEM → usa localStorage
            if (serverAddresses.length === 0 && [storedAddressesTemp][0].city) {
                setDeliveryAddresses([storedAddressesTemp]);
                return;
            }

            // 2 — Se servidor NÃO tem endereços e localStorage NÃO tem → usa servidor (array vazio)
            if (serverAddresses.length > 0) {
                setDeliveryAddresses(serverAddresses);
                return;
            }

            if (serverAddresses.length === 0 && storedAddressesTemp.length === 0) {
                setDeliveryAddresses([]);
                return;
            }

        } catch (error) {
            console.error('Erro ao checar profile:', error);
        }
    };

    useEffect(() => {
        if (partner === null) {
            const checkPartner = async () => {
                try {
                    const fetchPartner = async () => {
                        try {
                            const response = await ShopperRequest(cart.cart.loja.id);
                            if (response.status === 200) {
                                setPartner(response.data.result)
                                setLoading(false)
                            } else {
                                console.error('Erro ao obter os produtos:', response.statusText);
                                setLoading(false)
                            }
                        } catch (error) {
                            console.error('Erro ao obter os produtos:', error);
                            setLoading(false)
                        }
                    };
                    fetchPartner();
                } catch (error) {
                    console.error('Erro ao obter o valor de "p" da URL:', error);
                    setLoading(false)
                }
            };
            checkPartner();
        }
    }, [partner]);

    const createNewAddress = async (newAddress) => {
        try {
            const fetchProfile = async () => {
                try {
                    const response = await createAddress(
                        newAddress.street,
                        newAddress.number,
                        newAddress.neighborhood,
                        newAddress.city,
                        newAddress.state,
                        newAddress.zipcode,
                        newAddress.latitude,
                        newAddress.longitude
                    );

                    if (response.status === 200) {
                        const addressId = response.data?.data?.addressId;

                        const newAddressMock = {
                            ...newAddress,
                            id: addressId
                        };

                        localStorage.setItem(
                            'addressesTemp',
                            JSON.stringify(newAddressMock)
                        );

                        setModalNewAddress(false);
                        checkProfile();
                    } else {
                        console.error('Erro ao criar endereço:', response.statusText);
                    }
                } catch (error) {
                    console.error('Erro ao criar endereço:', error);
                }
            };

            fetchProfile();
        } catch (error) {
            console.error('Erro ao obter o valor de "p" da URL:', error);
        }
    };

    const mapOrderItems = (itensD) => {
        return itensD.map(item => ({
            quantity: item.quantidade,
            productId: item.produto.id
        }));
    };

    const sendOrder = async (CustomerId, ShippingAddressId, StoreId, OrderItems, PaymentMethodId, DeliveryRate, Discount) => {
        let dumbItens = mapOrderItems(OrderItems)
        try {
            setSendingOrder(true);
            const fetchProfile = async () => {
                try {
                    const response = await createOrder(CustomerId, ShippingAddressId, StoreId, dumbItens, PaymentMethodId, DeliveryRate, Discount)
                    if (response.status === 200) {
                        setModalSendOrder(false)
                        setModalSendOrderDone(true)
                        setItens([])
                        setOrderID(response.data.message)
                        const cartDummy = JSON.stringify({
                            cart: {
                                loja: {},
                                status: "pendente",
                                itens: [],
                                paymentmethodid: PaymentMethodId
                            }
                        });
                        localStorage.setItem('cart', cartDummy)
                    } else {
                        console.error('Erro ao criar endereço:', response.statusText);
                    }
                } catch (error) {
                    console.error('Erro ao criar endereço:', error);
                } finally {
                    setSendingOrder(false);
                }
            };
            fetchProfile();
        } catch (error) {
            setSendingOrder(false);
            console.error('Erro ao obter o valor de "p" da URL:', error);
        }
    };

    const confirmPaymentMethod = () => {
        cart.cart.paymentmethodid = paymentId;
        localStorage.setItem('cart', JSON.stringify(cart));
        setModalPayment(false)
    };

    const tempAddress = JSON.parse(
        localStorage.getItem('addressesTemp')
    );

    const resolvedDeliveryAddressId =
        deliveryAddressId && deliveryAddressId !== '-'
            ? deliveryAddressId
            : tempAddress?.id || null;

    useEffect(() => {
        if (!shopper) {
            checkProfile();
        }
    }, [shopper]);

    useEffect(() => {
        console.log('deliveryAddressId')
        console.log(deliveryAddressId)
        console.log('------------------------------')
    }, [deliveryAddressId]);

    return (
        <>
            {
                qtd !== 0 ?
                    <span style={{ display: 'flex', justifyContent: 'center', position: 'absolute', left: 'calc(50% + 65px)', top: '97px', zIndex: '9999', width: 20, height: 20, position: 'fixed', backgroundColor: 'rgb(245, 71, 73)', marginRight: -150, borderRadius: '100%', fontSize: 12, paddingTop: 2, color: 'white', }}>
                        {qtd}
                    </span>
                    : qtd === 0 ?
                        null
                        : null
            }
            <div className="row" style={{ paddingTop: 30 }}>
                <div className="col-12">
                    <div className="">
                        <div className="px-3">
                            {
                                valorTotal !== 0 ?
                                    <div className="row">
                                        <div className="col-12 pt-3 pb-3">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 text-primary">
                                                    <i className="fa-solid fa-location-dot"></i> Endereço da entrega
                                                </h5>
                                            </div>
                                            <div className="tracker-bx" style={{ padding: 10, boxShadow: '3px 3px 3px rgb(235 235 235)', borderRadius: 6, minHeight: 130, display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
                                                <span style={{ fontSize: 20 }}>
                                                    {
                                                        valorTotal !== 0 ?
                                                            deliveryAddresses.length > 0 ?
                                                                <span style={{ fontWeight: 'semibold', color: '#6c6c6c' }}>
                                                                    {
                                                                        deliveryAddresses[0].street +
                                                                        ', Nº '}
                                                                    {
                                                                        deliveryAddresses[0].number ? 
                                                                            deliveryAddresses[0].number : 'S/N'
                                                                    }
                                                                    {'' +
                                                                        ' , ' +
                                                                        deliveryAddresses[0].city +
                                                                        ' - ' + deliveryAddresses[0].state
                                                                    }
                                                                    {
                                                                        deliveryAddresses[0].zipCode? ' ( ' + deliveryAddresses[0].zipCode + ' ) ' : ''
                                                                    }
                                                                </span>
                                                                :
                                                                <span style={{ fontWeight: 'semibold' }}>
                                                                    Nenhum endereço cadastrado!
                                                                </span>
                                                            : 'Nenhum endereço cadastrado!'
                                                    }
                                                </span>
                                                {
                                                    deliveryAddresses.length > 0 ?
                                                        <button onClick={() => setModalAddress(true)} className='btn btn-light'>
                                                            <i className="fa-solid fa-repeat"></i>  trocar endereço de entrega
                                                        </button>
                                                    :
                                                        <button onClick={() => setModalNewAddress(true)} className='btn btn-light'>
                                                            cadastrar um endereço
                                                        </button>
                                                }
                                            </div>
                                        </div>
                                        <div className="col-12 pt-3 pb-3">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 text-primary">
                                                    <i className="fa-regular fa-credit-card"></i> Forma de pagamento
                                                </h5>
                                            </div>
                                            <div style={{ padding: 10, boxShadow: '3px 3px 3px rgb(235 235 235)', borderRadius: 6, minHeight: 130, display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
                                                <span style={{ fontSize: 20 }}>
                                                    {
                                                        paymentId === '-' ?
                                                            !cart.cart.paymentmethodid ?
                                                                <span style={{ fontWeight: 'semibold', color: '#6c6c6c' }}>
                                                                    forma de pagamento não selecionada
                                                                </span>
                                                                : <span style={{ fontWeight: 'semibold', color: '#6c6c6c' }}>
                                                                    {(() => {
                                                                        const selectedPaymentMethod = paymentMethodsNIDs.find(method => method.id === cart.cart.paymentmethodid);
                                                                        return selectedPaymentMethod ? selectedPaymentMethod.method : 'Método de pagamento desconhecido';
                                                                    })()}
                                                                </span>
                                                            : <span style={{ fontWeight: 'semibold', color: '#6c6c6c' }}>
                                                                {(() => {
                                                                    const selectedPaymentMethod = paymentMethodsNIDs.find(method => method.id === paymentId);
                                                                    return selectedPaymentMethod ? selectedPaymentMethod.method : 'Método de pagamento desconhecido';
                                                                })()}
                                                            </span>
                                                    }
                                                </span>
                                                <button onClick={() => setModalPayment(true)} className='btn btn-light'>
                                                    <i className="fa-solid fa-repeat"></i> trocar forma de pagamento
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    : null
                            }
                            <div className="order-menu style-3">
                                <h5 className="my-4 text-primary"><i className="fa-solid fa-bag-shopping"></i> Produtos</h5>
                                {
                                    valorTotal !== 0 ?
                                        itens.map((item, ind) => (
                                            <div className="d-flex align-items-center justify-content-between flex-wrap mb-3 gap-3" style={{ boxShadow: '3px 3px 3px rgb(235 235 235)', padding: 10, borderRadius: 6 }} key={'itens-' + ind}>
                                                <div className='d-flex align-items-center gap-3'>
                                                    {
                                                        !item.produto.images ?
                                                            <span style={{
                                                                width: 50,
                                                                height: '6vh',
                                                                backgroundImage: "gray",
                                                                margin: '0 auto',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center', gap: 2, backgroundColor: 'rgb(241 241 241)'
                                                            }}>
                                                                <i className='bi bi-gift' style={{ fontSize: 45, color: 'white' }} />
                                                            </span>
                                                            :
                                                            <span style={{
                                                                width: 70,
                                                                height: 70,
                                                                margin: '0 auto',
                                                                justifyContent: 'center',
                                                                overflow: 'hidden',
                                                                display: 'flex',
                                                                borderRadius: 6,
                                                                border: '1px #dedede solid',
                                                                backgroundColor: 'white',
                                                            }}>
                                                                <img className="" style={{ border: '0px', height: '100%', width: 'auto', display: 'block', margin: '0 auto' }} src={'https://core.pskeromais.com.br/' + item.produto.images[0].url} />
                                                            </span>
                                                    }
                                                    <span style={{ display: 'flex', flexDirection: 'column' }}>
                                                        <h4 className="font-w600 text-nowrap mb-0">{item.produto.name}</h4>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                            <button onClick={() => qtfcr('minus', item.produto)} className="btn btn-primary d-flex justify-content-center align-items-center" style={{ fontSize: 11, width: 30, height: 30 }}>
                                                                <i className="bi bi-dash" style={{ fontSize: 16 }}></i>
                                                            </button>
                                                            <span style={{
                                                                minWidth: 36,
                                                                minHeight: 36,
                                                                width: 38,
                                                                height: 38,
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                borderRadius: '50%',
                                                                background: '#e0e0e0',
                                                                fontWeight: 'bold',
                                                                fontSize: 22,
                                                                color: '#333',
                                                                margin: '0 6px',
                                                                border: '2px solid #bdbdbd',
                                                            }}>{getQtdInCart(item.produto.id)}</span>
                                                            <button onClick={() => qtfcr('plus', item.produto)} className="btn btn-secondary d-flex justify-content-center align-items-center" style={{ fontSize: 11, width: 30, height: 30 }}>
                                                                <i className="bi bi-plus" style={{ fontSize: 16 }}></i>
                                                            </button>
                                                        </div>
                                                    </span>
                                                </div>
                                                <div className="d-flex" style={{ flexDirection: 'row', gap: 10 }}>
                                                    <span style={{ display: 'flex', flexDirection: 'column' }}>
                                                        <label style={{ margin: 0 }}>unit.</label>
                                                        <span className="mb-0" style={{ backgroundColor: 'rgb(231 231 231)', padding: '6px 15px', borderRadius: 5, fontWeight: 'bold' }}>{item.produto.salePrice.toFixed(2)} R$ <span style={{ width: 1, height: 30, position: 'absolute', right: '-8px', backgroundColor: 'rgb(231 231 231)' }} /></span>
                                                    </span>
                                                    <span style={{ display: 'flex', flexDirection: 'column' }}>
                                                        <label style={{ margin: 0 }}>total</label>
                                                        <span className="text-primary mb-0" style={{ backgroundColor: 'rgb(231 231 231)', padding: '6px 15px', borderRadius: 5, fontWeight: 'bold' }}>{(item.quantidade * item.produto.salePrice).toFixed(2) + " R$"}</span>
                                                    </span>
                                                </div>
                                            </div>
                                        ))
                                        :
                                        <div className="d-flex align-items-center justify-content-between flex-wrap mb-3 gap-3" style={{ boxShadow: '3px 3px 3px rgb(235 235 235)', padding: 10, borderRadius: 6, flexDirection: 'column' }}>

                                            <h2 style={{ margin: 0 }}><i className="bi bi-cart"></i></h2>
                                            <h4 style={{ color: 'gray' }}>nenhum produto adicionado ao carrinho</h4>

                                        </div>
                                }
                            </div>
                            {
                                valorTotal !== 0 ?
                                    <>
                                        <div className="d-flex mb-3 mt-3" style={{ maxWidth: 450, textAlign: 'center', margin: '30px auto', flexDirection: 'row', gap: 6, justifyContent: 'center' }}>
                                            {/* <span style={{ padding: 6, backgroundColor: 'white', boxShadow: '3px 3px 3px rgb(235 235 235)', borderRadius: 6 }}>
                                                <h4 style={{ position: 'relative', color: 'rgb(115 153 9)' , margin: 0 }}>{orderDiscount.toFixed(2)} R$</h4>
                                                <span style={{ color: 'gray' }}>desconto</span>
                                            </span> */}
                                            <span style={{ padding: 6, backgroundColor: 'white', boxShadow: '3px 3px 3px rgb(235 235 235)', borderRadius: 6 }}>
                                                <span style={{ color: 'gray' }}> taxa de entrega</span>
                                                <h3 style={{ position: 'relative', color: 'rgb(115 153 9)', margin: 0 }}>{partner ? partner.deliveryTax.toFixed(2) : ''} R$</h3>
                                            </span>
                                            <span style={{ padding: 6, backgroundColor: 'white', boxShadow: '3px 3px 3px rgb(235 235 235)', borderRadius: 6 }}>
                                                <span style={{ color: 'gray' }}>{quantidadeTotal} produtos</span>
                                                <h3 style={{ position: 'relative', color: 'rgb(115 153 9)', margin: 0 }}>{valorTotal.toFixed(2)} R$</h3>
                                            </span>
                                            <span style={{ padding: 6, backgroundColor: 'white', boxShadow: '3px 3px 3px rgb(235 235 235)', borderRadius: 6 }}>
                                                <span style={{ color: 'gray' }}>total</span>
                                                <h3 style={{ position: 'relative', color: 'rgb(115 153 9)', margin: 0 }}>{partner ? ((valorTotal + partner.deliveryTax) - orderDiscount).toFixed(2) : ''} R$</h3>
                                            </span>
                                        </div>
                                    </>
                                    : null
                            }
                            <br />
                            {
                                valorTotal !== 0 ?
                                    <div className="d-flex gap-3 mt-3" style={{ maxWidth: 350, textAlign: 'center', margin: '30px auto', flexDirection: 'row', justifyContent: 'center' }}>
                                        <button onClick={() => setModalSendOrder(true)} className='btn btn-primary'>
                                            <i className="fa-solid fa-motorcycle"></i> enviar pedido
                                        </button>
                                    </div>
                                    : null
                            }
                        </div>
                    </div>
                </div>
            </div>
            <Modal show={modalAddress} onHide={setModalAddress} centered>
                <button onClick={() => setModalAddress(false)} className='btn btn-light p-1' style={{ width: 30, height: 30, position: 'absolute', right: 6, top: 6, borderRadius: '100%' }}>
                    <i className="bi bi-x-circle" style={{ fontSize: 14 }}></i>
                </button>
                <div className='d-flex align-items-center justify-content-center flex-column p-4' style={{ minHeight: 300 }}>
                    <h4 style={{ borderBottom: '1px solid #f1f1f1', paddingBottom: 7 }}><i className="fa-solid fa-location-dot"></i> Trocar Endereço</h4>
                    <br />
                    <select className="form-select"
                        value={deliveryAddressId}
                        onChange={(e) => setDeliveryAddressId(e.target.value)}
                    >
                        {deliveryAddresses.map((address, index) => (
                            <option key={'deliveryAddresses-' + index} value={address.id}>
                                {`${address.street} ( ${address.zipCode} ) , Nº ${address.number || 'S/N'}, ${address.city} - ${address.state}`}
                            </option>
                        ))}
                    </select>
                    <br />
                    <div className='d-flex align-items-center justify-content-center flex-row' style={{ gap: 4 }}>
                        <button onClick={() => setModalAddress(false) } className='btn btn-primary'>
                            confirmar
                        </button>
                        <button onClick={() => {
                            setModalAddress(false);
                            setModalNewAddress(true);
                        }} className='btn btn-dark' style={{ border: '1px gray solid' }}>
                            cadastrar novo endereço
                        </button>
                        <button onClick={() => 
                            setModalAddress(false)
                        } className='btn btn-light'>
                            cancelar
                        </button>
                    </div>
                </div>
            </Modal>
            <Modal show={modalPayment} onHide={setModalPayment} centered>
                <button onClick={() => setModalPayment(false)} className='btn btn-light p-1' style={{ width: 30, height: 30, position: 'absolute', right: 6, top: 6, borderRadius: '100%' }}>
                    <i className="bi bi-x-circle" style={{ fontSize: 14 }}></i>
                </button>
                <div className='d-flex align-items-center justify-content-center flex-column p-4' style={{ minHeight: 300 }}>
                    <h4 style={{ borderBottom: '1px solid #f1f1f1', paddingBottom: 7 }}><i className="fa-regular fa-credit-card"></i> Trocar Forma de Pagamento</h4>
                    <br />
                    <select className="form-select" onChange={(e) => setPaymentId(e.target.value)}>
                        {paymentMethodsNIDs.map((method) => (
                            <option key={'paymentMethodsNIDs-' + method.id} value={method.id} selected={method.id === paymentId || method.id === cart.cart.paymentmethodid ? "selected" : null}>
                                {method.method}
                            </option>
                        ))}
                    </select>
                    <br />
                    <div className='d-flex align-items-center justify-content-center flex-row' style={{ gap: 4 }}>
                        <button onClick={() => confirmPaymentMethod()} className='btn btn-primary'>
                            confirmar
                        </button>
                        <button onClick={() => {
                            setModalPayment(false);
                            setPaymentId('-');
                        }} className='btn btn-light'>
                            cancelar
                        </button>
                    </div>
                </div>
            </Modal>
            <Modal show={modalNewAddress} onHide={setModalNewAddress} centered>
                <button onClick={() => setModalNewAddress(false)} className='btn btn-light p-1' style={{ width: 30, height: 30, position: 'absolute', right: 6, top: 6, borderRadius: '100%' }}>
                    <i className="bi bi-x-circle" style={{ fontSize: 14 }}></i>
                </button>
                <div className='d-flex align-items-center justify-content-center flex-column p-4' style={{ minHeight: 300 }}>
                    <h4 style={{ borderBottom: '1px solid #f1f1f1', paddingBottom: 7 }}><i className="fa-solid fa-location-dot"></i> Cadastrar Novo Endereço </h4>
                    <br />
                    <NewAddressFormD
                        onSelectAddress={(addr) => createNewAddress(addr)}
                    />
                </div>
            </Modal>
            <Modal show={modalSendOrder} onHide={setModalSendOrder} centered>
                <button onClick={() => setModalSendOrder(false)} className='btn btn-light p-1' style={{ width: 30, height: 30, position: 'absolute', right: 6, top: 6, borderRadius: '100%' }}>
                    <i className="bi bi-x-circle" style={{ fontSize: 14 }}></i>
                </button>
                <div className='d-flex align-items-center justify-content-center flex-column p-4' style={{ minHeight: 300 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                        <h2 className='text-primary text-center'><i className="fa-solid fa-motorcycle"></i></h2>
                        <h4 style={{ borderBottom: '1px solid #f1f1f1', paddingBottom: 7 }}> Confirmar Pedido ?</h4>
                    </div>
                    {!deliveryAddressId  && (
                        <>
                            <h4 className='text-danger'>selecione um endereço</h4>
                            <button
                                className='btn btn-light'
                                onClick={() => {
                                    setModalSendOrder(false);
                                    setModalAddress(true);
                                }}
                            >
                                selecionar endereço
                            </button>
                        </>
                    )}

                    {!cart.cart.paymentmethodid && (
                        <>
                            <h4 className='text-danger'>selecione um método de pagamento</h4>
                            <button
                                className='btn btn-light'
                                onClick={() => {
                                    setModalSendOrder(false);
                                    setModalPayment(true);
                                }}
                            >
                                selecionar pagamento
                            </button>
                        </>
                    )}
                    <div style={{ display: 'flex', flexDirection: 'row', gap: 5 }}>
                        <button
                            onClick={() => sendOrder(
                                shopper.id,
                                resolvedDeliveryAddressId,
                                cart.cart.loja.id,
                                cart.cart.itens,
                                cart.cart.paymentmethodid,
                                partner.deliveryTax,
                                orderDiscount
                            )}
                            className='btn btn-primary'
                            disabled={
                                !resolvedDeliveryAddressId ||
                                !cart.cart.paymentmethodid ||
                                sendingOrder
                            }
                        >
                            {sendingOrder ? 'enviando o pedido...' : 'confirmar pedido'}
                        </button>
                        <button className="btn btn-primary-outline border-primary text-primary" onClick={() => setModalSendOrder()} disabled={sendingOrder}>
                            cancelar
                        </button>
                    </div>
                </div>
            </Modal>
            <Modal show={modalSendOrderDone} onHide={setModalSendOrderDone} centered>
                <button onClick={() => setModalSendOrderDone(false)} className='btn btn-light p-1' style={{ width: 30, height: 30, position: 'absolute', right: 6, top: 6, borderRadius: '100%' }}>
                    <i className="bi bi-x-circle" style={{ fontSize: 14 }}></i>
                </button>
                <div className='d-flex align-items-center justify-content-center flex-column p-4' style={{ minHeight: 300 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                        <h2 className='text-primary text-center'><i className="fa-solid fa-motorcycle"></i></h2>
                        <h4 style={{ borderBottom: '1px solid #f1f1f1', paddingBottom: 7 }}> Confirmar Pedido ?</h4>
                    </div>
                    <br />
                    <a className='btn btn-primary' href={`/pedido?p=${orderID}`} >
                        acompanhar pedido
                    </a>
                </div>
            </Modal>
            <span style={{ zIndex: 9999, width: '100%', height: '100vh', backgroundColor: 'rgba(41 ,180,226,0.6)', position: 'absolute', top: 0, right: 0, display: loading ? 'flex' : 'none', justifyContent: 'center', alignItems: 'center' }} >
                <i id="loading-arrow-in-circle" className="bi bi-arrow-clockwise" style={{ color: 'white', fontSize: 75 }}></i>
            </span>
        </>
    )
}
export default FoodOrder;

const NewAddressFormD = ({ onSelectAddress }) => {
    const [formData, setFormData] = useState({
        Street: '',
        Number: '',
        Neighborhood: '',
        City: '',
        State: '',
        ZipCode: '',
        latitude: 0,
        logintude: 0
    });

    const [query, setQuery] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedMap, setSelectedMap] = useState(false);

    const extractNumberFromQuery = (input) => {
        const match = input.match(/\b\d+\b/);
        return match ? match[0] : "";
    };

    const removeNumberFromQuery = (input, number) => {
        if (!number) return input;
        return input.replace(number, "").replace(/\s{2,}/g, " ").trim();
    };

    const searchAddress = async () => {
        if (!query || query.length < 3) {
            setSuggestions([]);
            return;
        }

        const number = extractNumberFromQuery(query);
        const queryWithoutNumber = removeNumberFromQuery(query, number);

        try {
            const response = await fetch(
                `https://bot.pskeromais.com.br/api/street-founder?q=${encodeURIComponent(
                    queryWithoutNumber
                )}`
            );
            const data = await response.json();
            setSuggestions(Array.isArray(data) ? data : []);
            setShowModal(true);
        } catch (error) {
            console.error("Erro ao buscar endereço OSM:", error);
            setSuggestions([]);
            setShowModal(true); // abre modal mesmo que vazio (pode exibir "Nenhum endereço")
        } finally {
            setLoading(false);
        }
    };

    const formatAddress = (item, number = "") => {
        const addr = item.address || {};
        return [
            [addr.road, number || addr.house_number].filter(Boolean).join(", "), // rua + número
            addr.suburb, // bairro
            addr.city || addr.town || addr.village, // cidade
            addr.state, // estado
            addr.postcode, // CEP
            addr.country, // país
        ]
            .filter(Boolean)
            .join(", ");
    };

    const handleSelect = (item) => {
        const number = extractNumberFromQuery(query); // pega o número que o usuário digitou
        const formatted = formatAddress(item, number);
        setQuery(formatted);
        setSuggestions([]);
        setSelectedMap(true);
        const { address, lat, lon } = item;
        const payload = {
            number: number || address.house_number || "",
            street: address.road || "",
            city: address.city || address.town || address.village || "",
            state: address.state || "",
            zipcode: address.postcode || "",
            neighborhood: address.suburb || "",
            country: 'Brasil',
            latitude: parseFloat(lat) || 0,
            longitude: parseFloat(lon) || 0,
        };

        setFormData(payload);
    };

    return (
        <div style={{ position: "relative", width: '100%' }}>
            <div style={{ display: "flex", gap: 6, width: '100%' }}>
                <input
                    type="text"
                    className="form-control"
                    placeholder="Digite seu endereço"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                />
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                        setLoading(true);
                        searchAddress();
                    }}
                    disabled={query.length < 3 || loading}
                    title="Buscar endereço"
                >
                    <i className="bi bi-search" />
                </button>
            </div>

            {loading && <div style={{ marginTop: 6, fontSize: 16, margin: "13px 0" }}><div className="spinner-border text-primary" role="status">
                <span className="visually-hidden"></span>
            </div> Procurando endereço...</div>
            }

            {selectedMap &&
                <div className="row mt-2">
                    <div className="col-md-12 mb-2">
                        <MapContainer
                            center={[
                                parseFloat(formData.latitude) || -15.7797,
                                parseFloat(formData.longitude) || -47.9297,
                            ]}
                            zoom={15}
                            style={{ height: "300px", width: "100%" }}
                        >
                            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                            <Marker
                                position={[
                                    parseFloat(formData.latitude) || -15.7797,
                                    parseFloat(formData.longitude) || -15.7797,
                                ]}
                            />
                        </MapContainer>
                        <div
                            style={{
                                backgroundColor: "rgb(233 233 233)",
                                borderRadius: 5,
                                padding: "10px 15px",
                            }}
                        >
                            <p><b>Rua:</b> {formData.street || "-"}</p>
                            <p><b>Número:</b> {formData.number || "-"}</p>
                            <p><b>Bairro:</b> {formData.neighborhood || "-"}</p>
                            <p>
                                <b>Cidade:</b> {formData.city} -{" "}
                                {formData.state}
                            </p>
                            <p><b>CEP:</b> {formData.zipCode || "-"}</p>
                        </div>
                    </div>

                    <div className="col-12 text-center mt-3">
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => onSelectAddress(formData)}
                        >
                            Alterar endereço
                        </button>
                    </div>
                </div>
            }

            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <button
                    onClick={() => setShowModal(false)}
                    className="btn btn-light p-1"
                    style={{
                        width: 30,
                        height: 30,
                        position: "absolute",
                        right: 6,
                        top: 6,
                        borderRadius: "100%",
                        zIndex: 1051,
                    }}
                >
                    <i className="bi bi-x-circle" style={{ fontSize: 14 }}></i>
                </button>

                <div
                    className="d-flex align-items-center justify-content-center flex-column p-4"
                    style={{ minHeight: 200 }}
                >
                    <h4 style={{ borderBottom: "1px solid #f1f1f1", paddingBottom: 7 }}>
                        <i className="fa-solid fa-location-dot"></i> Endereços encontrados
                    </h4>
                    <br />
                    <div style={{ width: "100%" }}>
                        {loading ? (
                            <p>Carregando...</p>
                        ) : suggestions.length > 0 ? (
                            <ul
                                className="list-group"
                                style={{ maxHeight: 300, overflowY: "auto" }}
                            >
                                {suggestions.map((item) => (
                                    <li
                                        key={item.place_id}
                                        className="list-group-item list-group-item-action"
                                        style={{
                                            cursor: "pointer",
                                            backgroundColor: "#fff",
                                            display: "flex",
                                            gap: 8,
                                            alignItems: "center",
                                        }}
                                        onClick={() => (handleSelect(item), setShowModal(false))}
                                    >
                                        <i className="bi bi-geo-alt" style={{ fontSize: 18 }} />
                                        <div style={{ lineHeight: 1.1 }}>
                                            {formatAddress(item, extractNumberFromQuery(query))}
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p>Nenhum endereço encontrado.</p>
                        )}
                    </div>
                </div>
            </Modal>
        </div>
    );
};